var React = require('react');

function MehRollingEyes (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM88,224a64,64,0,1,1,64,64A64,64,0,0,1,88,224ZM312,400H184c-21.2,0-21.2-32,0-32H312C333.2,368,333.2,400,312,400Zm32-112a64,64,0,1,1,64-64A64,64,0,0,1,344,288Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M375,168a64,64,0,0,0-62,0,32,32,0,1,0,62,0Zm-223-8a63.66,63.66,0,0,0-31,8,32,32,0,1,0,62,0A63.66,63.66,0,0,0,152,160Z","className":"fa-primary","key":2})]);
}

MehRollingEyes.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = MehRollingEyes;

MehRollingEyes.default = MehRollingEyes;
